import lfRequest from "@/service/index";

// /customerDetails/queryCustomerList
export function queryCustomerList(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/customerDetails/queryCustomerList',
    params: queryInfo
  })
}

// /customerDetails/queryCustomerDetailsInfo
export function queryCustomerDetailsInfo(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/customerDetails/queryCustomerDetailsInfo',
    params: queryInfo
  })
}

// /customerDetails/getCustomerTrailRecords
export function getCustomerTrailRecords(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/customerDetails/getCustomerTrailRecords',
    params: queryInfo
  })
}

// /customerDetails/getCustomerTrack
export function getCustomerTrack(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/customerDetails/getCustomerTrack',
    params: queryInfo
  })
}

// /customerDetails/getManagerSuggestion
export function getManagerSuggestion(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/customerDetails/getManagerSuggestion',
    params: queryInfo
  })
}
